export var ComponentType;
(function (ComponentType) {
  ComponentType["LINK_LIST_ITEM_WIDGET"] = "LINK_LIST_ITEM_WIDGET";
  ComponentType["CALLOUT_WIDGET"] = "CALLOUT_WIDGET";
  ComponentType["BUTTON_WIDGET"] = "BUTTON_WIDGET";
  ComponentType["PROGRESS_BAR_WIDGET"] = "PROGRESS_BAR_WIDGET";
  ComponentType["DIVIDER_WIDGET"] = "DIVIDER_WIDGET";
  ComponentType["BENEFITS_WIDGET"] = "BENEFITS_WIDGET";
  ComponentType["TYPOGRAPHY_HEADING"] = "TYPOGRAPHY_HEADING";
  ComponentType["TYPOGRAPHY_SUB_TEXT"] = "TYPOGRAPHY_SUB_TEXT";
  ComponentType["KEY_PAIR_UNIT_WIDGET"] = "KEY_PAIR_UNIT_WIDGET";
  ComponentType["PRICE_BREAKUP_WIDGET"] = "PRICE_BREAKUP_WIDGET";
  ComponentType["IMAGE_CONTAINER_WIDGET"] = "IMAGE_CONTAINER_WIDGET";
})(ComponentType || (ComponentType = {}));